import { getSingleInstanceByElement, initialiseComponents } from '../../../core'
import Component from '../../component.abstract'
import ValidatedInput from '../../form/validated-input/validated-input'
import { hw } from '../../helpers/paths'

interface SimplePasswordProps {
    label?: string,
    name?: string,
    message?: string,
    minLength?: number,
    minlengthMsg?: string,
    required?:boolean,
    showStrengh?:boolean,
    titleClass?: string,
    inputClass?: string
}

/**
 * Houdini Component
 * force a dispay:block on a element for SEO purpose
 */
export default class SimplePassword extends Component {
    private password:HTMLInputElement
    private readonly addedprops = {
        label: 'Mot de passe',
        name: 'password'
    }
    private titleClass: string;
    private inputClass: string;

    constructor(
        private props:SimplePasswordProps,
        element:HTMLElement
    ) {
        super(props, element);

        if (this.props.label) {
            this.addedprops.label = this.props.label;
        }

        if (this.props.name) {
            this.addedprops.name = this.props.name;
        }

        this.titleClass = this.props.titleClass ?? "";
        this.inputClass = this.props.inputClass ?? "";
    }

    /**
     * set template and events
     */
    mounted():void {
        this.setTemplate()
        this.password = this.element.querySelector("[data-sp-password]");

        this.element
            .querySelector("[data-sp-eyes]")
            .addEventListener("click", (e) => this.togglePassword(e));

        if (this.props.showStrengh) {
            this.password.addEventListener("keyup", () => this.onPasswordKeyUp())
            this.password.addEventListener('input', (e) => this.onPasswordInput(e))
            this.password.addEventListener('blur', (e) => this.onPasswordBlur(e))
        }
        initialiseComponents();
    }

    /**
     * Set Template with conditional rendering
     */
    setTemplate () {
        this.element.innerHTML = `
            <label data-sp-label class="simplePassword__title ${this.titleClass}">${this.addedprops.label}</label>
            <div class="simplePassword__wrapper-holder ${this.inputClass}">
                <div class="simplePassword__wrapper-inner">
                    <input
                        name="${this.addedprops.name}"
                        type="password"
                        data-password-strength-meter="true"
                        data-sp-password
                        class="simplePassword__input"
                        ${this.props.required ? `data-val data-val-required` : ''}
                        ${this.props.message ? `data-msg-required="${this.props.message}"` : ''}
                        ${this.props.minLength ? `data-rule-minlength=${this.props.minLength}` : ''}
                        ${this.props.minlengthMsg ? `data-msg-minlength="${this.props.minlengthMsg}"` : ''}>

                    ${this.props.showStrengh ? this.setPasswordStrengthMeterTemplate() : ''}

                    <div data-sp-eyes class="simplePassword__toggle" />
                         <svg data-load-url="${hw.getBaseRessourcesUrl()}/img/svg/eye.svg"></svg>
                         <svg data-load-url="${hw.getBaseRessourcesUrl()}/img/svg/crossed-eye.svg"></svg>
                    </div>
                    ${this.props.required ? `<span data-valmsg-for="${this.addedprops.name}"></span>` : ''}
            </div>
        `
    }

    /**
     * Set Template for strength meter part
     */
    setPasswordStrengthMeterTemplate () {
        return `
        <div class="password-strength-meter">
            <div class="password-strength-meter__progress-bar">
                <div class="progress-level"></div>
            </div>
            <div class="password-strength-meter__label">
                <div class="password-strength-meter__label__tooltip">
                    <span class="tooltip-level"></span>
                    <div class="password-strength-meter__label__tooltip__content">
                        Pour sécuriser votre mot de passe, saisissez au moins 8 caractères et utilisez des majuscules, minuscules, chiffres et caractères spéciaux.
                    </div>
                </div>
            </div>
        </div>
        `
    }

    /**
     * Apply class for strength meter on keyup
     */
    onPasswordKeyUp () {
        this.element.classList.add("with-strengh-meter");
    }

    /**
     * Check level and toggle classes for strength meter on input
     * @param inputEvent
     */
    onPasswordInput (inputEvent: Event) {
        const value = (inputEvent.target as HTMLInputElement).value
        const progressLevel = this.element.querySelector('.progress-level')
        const tooltipLevel = this.element.querySelector('.tooltip-level')

        if (value.length === 0) {
            progressLevel.className =  'progress-level';
            tooltipLevel.className = 'tooltip-level';
        } else {
            let strength = window.zxcvbn(value).score
            // No check improve level
            if (strength === 4) {
                strength--
            }

            progressLevel.className = `progress-level level${strength}`
            tooltipLevel.className = `tooltip-level level${strength}`
        }
    }

    /**
     * Check level and apply class for strength meter on blur
     * @param inputEvent
     */
    onPasswordBlur (inputEvent: FocusEvent) {
        const element = inputEvent.target as HTMLInputElement
        const strength = window.zxcvbn(element.value).score 

        if (strength < 2) {
            element.classList.add('input-validation-error')
        }
    }

    /**
     * On click - toggle password/text for input
     * @param event
     */
    togglePassword (event:Event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        (<HTMLElement> event.currentTarget).classList.toggle("simplePassword__toggle--show")
        this.password.type = this.password.type === 'password' ? 'text' : 'password'
    }

    check () {
        let valid = true;

        if (this.props.required == true) {
            const validatorInstance: ValidatedInput = getSingleInstanceByElement("ValidatedInput", this.element.querySelector(".simplePassword__input"))
            valid = validatorInstance.check();
        }

        return valid;
    }

    getValue(): string {
        return this.password.value;
    }

    clear(): void {
        this.password.value = "";
    }
}